import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { InfoBlock, InfoBlockType } from 'cng-common/components/infoBlock'
import { Translation } from 'cng-common/features/translations'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { AbsolutePopup } from 'core-components/library/popup'
import { TRANSLATION_KEYS } from 'partner360/features/topPartnersManagement/translations'
import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'
import { IPartnerWithFlagRequests } from 'partner360/models/partnerFlagRequests/IPartnerWithFlagRequests'

import { PartnerFlagRequestDetails } from '../../../../partnerFlagRequestHistoryCard/PartnerFlagRequestDetails'

import styles from './RequestStatus.module.scss'

interface IRequestStatusProps {
  item: IPartnerWithFlagRequests
  partnerFlags: IP360PartnerFlags[]
}

export const RequestStatus = ({ item, partnerFlags }: IRequestStatusProps) => {
  const translationMode = useSelector(selectTranslationMode)
  const isTranslationMode = translationMode === TranslationMode.Edit

  const getDetail = useCallback(() => {
    return (
      <AbsolutePopup
        popupContent={() => <PartnerFlagRequestDetails item={item} partnerFlags={partnerFlags} />}
      >
        <span className={styles.seeDetails}>
          <Translation span text={TRANSLATION_KEYS.topPartners.editModal.seeDetails} />
        </span>
      </AbsolutePopup>
    )
  }, [item, partnerFlags])

  if (isTranslationMode) {
    return (
      <div>
        <Translation span text={TRANSLATION_KEYS.topPartners.editModal.seeDetails} />
        <Translation text={TRANSLATION_KEYS.topPartners.editModal.newMessage} />
        <Translation text={TRANSLATION_KEYS.topPartners.editModal.wipMessage} />
      </div>
    )
  }

  if (item.RequestStatus === 'New') {
    return (
      <InfoBlock
        hasIcon
        customIconClass={'kbase kbase-warning'}
        type={InfoBlockType.Warning}
        text={
          <div>
            <Translation text={TRANSLATION_KEYS.topPartners.editModal.newMessage} />
            {getDetail()}
          </div>
        }
      />
    )
  }

  if (item.RequestStatus === 'Wip') {
    return (
      <InfoBlock
        hasIcon
        customIconClass={'kbase kbase-warning'}
        type={InfoBlockType.Help}
        text={
          <div>
            <Translation text={TRANSLATION_KEYS.topPartners.editModal.wipMessage} />
            {getDetail()}
          </div>
        }
      />
    )
  }

  return null
}
